import { createReducer, on } from "@ngrx/store";
import { pinsheetDatesAction } from "../actions/pinsheet-dates.action";
import { PinsheetDates } from "../models/pinsheet-dates.model";

export const initialState: ReadonlyArray<PinsheetDates> = []

export const pinsheetDatesReducer = createReducer(
    initialState,
    on(pinsheetDatesAction, (state, { pinsheetDatesData }) => pinsheetDatesData)
)